document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mnp-footer-accordion]').forEach(function (accordion) {
    var trigger = accordion.querySelector('[data-mnp-footer-accordion-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');
      accordion.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('[data-mnp-cookie-settings]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openCookiePreferences();
    });
  });
});

function openCookiePreferences() {
  var showPreferences = function () {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }
    return false;
  };

  if (showPreferences()) return;

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      function (error) {
        if (!error) showPreferences();
      }
    );
  }
}
